import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import styles from './LeftMenu.module.scss';

export const createItemTypeClassGetter = (
  layerSpecificType: MENU_ITEM_TYPE,
  layerSpecificClass: string,
) => (itemType: MENU_ITEM_TYPE): string => {
  switch (itemType) {
    case MENU_ITEM_TYPE.CONSTANT:
      return styles.constantItem;

    case layerSpecificType:
      return layerSpecificClass;

    default:
      return styles.promotedItem;
  }
};
